import { createFileRoute } from '@tanstack/react-router'
import NotificationPreferences from '@/components/NotificationPreferences'

export const Route = createFileRoute('/_auth/notifications/preferences')({
  component: NotificationPreferencesPage,
})

function NotificationPreferencesPage() {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-display font-bold text-white mb-2">
            Preferências de Notificações
          </h1>
          <p className="text-gray-400 font-body">
            Configure como e quando você deseja receber notificações sobre suas férias e solicitações.
          </p>
        </div>

        <NotificationPreferences />
      </div>
    </div>
  )
}
